import { logStartUsage } from 'owa-analytics-start/lib/logStartUsage';
import { trace } from 'owa-trace';
import { equalityCheck } from './equalityCheck';

export function owaNetCoreEqualityCheck(
    owaResponse: any,
    netcoreResponse: any,
    actionName: string,
    matchValue?: boolean,
    matchArrayOrder?: boolean
): any {
    const check = equalityCheck(
        owaResponse,
        netcoreResponse,
        actionName,
        matchValue,
        matchArrayOrder
    );
    if (check.result) {
        return netcoreResponse;
    }
    trace.warn(`[NetCoreDiff] ${actionName} ${check.diff}`);
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logStartUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logStartUsage('NetCoreDiff', undefined, { actionName, diff: check.diff });
    return owaResponse;
}
